module.exports = function() {
  return new Worker(__webpack_public_path__ + "3af8028d95507e64ef36.worker.js");
};